import { getRegisterName } from '@/utils/form';

const REGISTER_NAME = getRegisterName(['MY_BIZ']);

export default REGISTER_NAME;
